module.exports = __webpack_public_path__ + "resources/img/bg_banner_tcc_m.fb3ba5cff0c63407d366be83f33570d3.jpg";